module.exports = __webpack_public_path__ + "img/undraw_Camera_re_cnp4.a6ece0c5.svg";